import { render, staticRenderFns } from "./CatalogManagementModal.vue?vue&type=template&id=bc404e40&scoped=true"
import script from "./CatalogManagementModal.vue?vue&type=script&lang=js"
export * from "./CatalogManagementModal.vue?vue&type=script&lang=js"
import style0 from "./CatalogManagementModal.vue?vue&type=style&index=0&id=bc404e40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc404e40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc404e40')) {
      api.createRecord('bc404e40', component.options)
    } else {
      api.reload('bc404e40', component.options)
    }
    module.hot.accept("./CatalogManagementModal.vue?vue&type=template&id=bc404e40&scoped=true", function () {
      api.rerender('bc404e40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/modals/CatalogManagementModal.vue"
export default component.exports